/**
 * @fileOverview invite.component.ts - Handling invites for people to join teams
 * @author Ivelin Ivanov
 */
var bindt = { vm: '<' };
var InviteController = (function () {
    function InviteController(socket, DTS, $q, $timeout, $stateParams, $state, $scope, $attrs, env, topic) {
        var _this = this;
        this.socket = socket;
        this.DTS = DTS;
        this.$q = $q;
        this.$timeout = $timeout;
        this.$stateParams = $stateParams;
        this.$state = $state;
        this.$scope = $scope;
        this.$attrs = $attrs;
        this.env = env;
        this.topic = topic;
        this.scopeId = this.DTS.guid();
        this.isManual = false;
        this.hasResult = false;
        this.hasText = false;
        this.isSelected = false;
        this.isDisabled = false;
        this.searchText = null;
        this.selectedItem = [];
        this.deferred = {};
        this.selectedTeams = [];
        this.arr = [];
        this.selectedEmails = [];
        this.clTEams = this.topic.topic.teams;
        this.socket.forward('add.members', this.$scope);
        this.$scope.$on('socket:add.members', function (event, data) {
            if (data === 'success') {
                _this.sendMail();
            }
        });
        this.socket.forward('get.members', this.$scope);
        this.$scope.$on('socket:get.members', function (event, data) {
            _this.clTEams = data;
        });
        this.socket.forward('typeahead.' + this.scopeId, this.$scope);
        this.$scope.$on('socket:typeahead.' + this.scopeId, function (event, data) {
            _this.lookupowner(event, data);
        });
    }
    InviteController.prototype.$onInit = function () {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'getTeams',
                script: '/config/config',
                data: {},
                token: this.env.user.token
            }
        });
    };
    InviteController.prototype.addMembers = function () {
        var emails = [];
        this.selectedEmails.forEach(function (mail) {
            if (mail.hasOwnProperty('email')) {
                emails.push(mail.email);
            }
        });
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'inviteMember',
                script: '/config/config',
                data: {
                    teamNames: this.selectedTeams,
                    mails: emails
                },
                token: this.env.user.token
            }
        });
    };
    InviteController.prototype.sendMail = function () {
        var emails = [];
        this.selectedEmails.forEach(function (mail) {
            if (mail.hasOwnProperty('email')) {
                emails.push(mail.email);
            }
        });
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'sendMail',
                script: '/mail/users',
                data: {
                    teams: this.selectedTeams,
                    mails: emails,
                    user: this.env.user.email
                },
                token: this.env.user.token
            }
        });
    };
    /**
   * Return the proper object when the append is called.
   */
    InviteController.prototype.transformChip = function (chip) {
        if (angular.isObject(chip)) {
            return chip;
        }
    };
    InviteController.prototype.lookupowner = function (event, data) {
        if (data.err) {
            return this.env.promises[data.id].reject([]);
        }
        this.env.promises[data.id].resolve(data.results);
        delete this.env.promises[data.id];
    };
    InviteController.prototype.searchTextChange = function (text) {
        var t = this;
        if (!text) {
            this.hasText = false;
        }
        else {
            this.hasText = true;
            this.searchText = text;
        }
    };
    InviteController.prototype.selectedItemChange = function () {
        var t = this;
        if (!this.hasText) {
            this.isSelected = false;
            this.hasResult = false;
        }
        else {
            this.isSelected = true;
            this.hasResult = true;
        }
    };
    InviteController.prototype.newPromise = function (socket, query) {
        var _this = this;
        var t = this;
        this.deferred = this.$q.defer();
        this.$timeout(function () {
            _this.deferred.reject([]);
        }, 5000);
        var id = this.DTS.guid();
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'lookUpUser',
                script: '/queue/typeahead',
                query: query,
                id: id,
                scope: this.scopeId,
                adminOnly: false,
                token: this.env.user.token
            }
        });
        this.env.promises[id] = this.deferred;
        return this.deferred.promise;
    };
    InviteController.prototype.querySearch = function (query) {
        var t = this;
        return this.newPromise(this.socket, query);
    };
    InviteController.$inject = ['socket', 'DTS', '$q', '$timeout', '$stateParams', '$state', '$scope', '$attrs', 'env', 'topic'];
    return InviteController;
}());
var InviteMemberComponent = (function () {
    function InviteMemberComponent() {
        this.bindings = bindt;
        this.templateUrl = 'invite.html';
        this.controller = InviteController;
    }
    return InviteMemberComponent;
}());
angular
    .module('application')
    .component('inviteSection', new InviteMemberComponent());

//# sourceMappingURL=invite.component.js.map
